import { capitalCase } from "change-case"

/** User-facing labels for deduction `status_value` (API/DB keys stay snake_case). */
export const DEDUCTION_STATUS_LABELS = {
  new: "New",
  validated: "Validated",
  disputable: "Disputable",
  backup_requested: "Backup Requested",
  backup_received: "Backup Received",
  review: "Review",
  task_assigned: "Task Assigned",
  disputed: "Disputed",
  won: "Won",
  expensable: "Expensable",
  lost: "Lost",
  archived: "Dispute Window Passed",
  pending: "Pending",
} as const

export function format_deduction_status_label(status: string): string {
  const label = DEDUCTION_STATUS_LABELS[status as keyof typeof DEDUCTION_STATUS_LABELS]
  if (label) {
    return label
  }
  return capitalCase(status)
}

if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest

  describe("format_deduction_status_label", () => {
    it("uses custom label for archived", () => {
      expect(format_deduction_status_label("archived")).toBe("Dispute Window Passed")
    })

    it("falls back to capitalCase for unknown statuses", () => {
      expect(format_deduction_status_label("misc")).toBe("Misc")
    })
  })
}
